import { Box, SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  noMarginX?: boolean;
  sx?: SxProps;
}

const BUTTON_SPACING = '1rem';

const ButtonRow = ({ noMarginX, sx, children }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      margin: BUTTON_SPACING,
      gap: BUTTON_SPACING,
      marginX: noMarginX ? 0 : BUTTON_SPACING,
      ...sx
    }}>
    {children}
  </Box>
);

export default ButtonRow;
